<template>
  <loading :loading="isLoading" :message="loadingMessage">
    <error :error="error"/>
    <slot v-if="data" v-bind:page="data"></slot>
  </loading>
</template>

<script>
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'

export default {
  props: ['pageName', 'parameters', 'loadingMessage'],
  components: { Loading, Error },
  data() {
    return {
      isLoading: true,
      error: null,
      data: null,
    };
  },
  mounted() {
    this.isLoading = true;
    this.error = null;
    this.$reportingApi.renderPage(
      'panessex', 
      this.$store.state.oidcStore.access_token, 
      {
        pageName: this.pageName,
        parameters: this.parameters,
      })
    .then((data) => {
      this.isLoading = false;
      this.data = data;
      this.$emit('data', this.data);
    })
    .catch((error) => {
      this.isLoading = false;
      this.error = error.message;
      this.$emit('error', error);
    });
  }
}
</script>
